// Status
export const TICKET_STATUS_ALL = {'id': 'ALL', 'label': 'Todos'}
export const TICKET_STATUS_OPEN = {'id': 'ST1', 'label': 'Abierto'}
export const TICKET_STATUS_IN_COURSE = {'id': 'ST2', 'label': 'En Curso'}
export const TICKET_STATUS_CLOSE = {'id': 'ST3', 'label': 'Cerrado'}

// Priorities
export const TICKET_PRIORITY_ALL = {'id': 'ALL', 'label': 'Todas'}
export const TICKET_PRIORITY_CRITICA = {'id': 'PR1', 'label': 'Critica'}

// Companies
export const TICKET_COMPANY_ALL = {'id': 'ALL', 'label': 'Todas'}


// Elements
export const TICKET_ELEMENT_ALL = {'id': 'ALL', 'label': ''}

export const PROFILE_ADMIN_CODE = 'KDF'

export const NAMES_ES: Record<string, string> = {
    'number': 'Número',
    'title': 'Título',
    'alarm': 'Alarma',
    'alarms': 'Alarmas',
    'code': 'Código',
    'name': 'Nombre',
    'status': 'Estado',
    'priority': 'Prioridad',
    'element': 'Elemento',
    'element_type': 'Tipo',
    'site': 'Sitio',
    'address': 'Dirección',
    'company': 'Compañía',
    'area': 'Área',
    'date': 'Fecha',
    'opening_date': 'Apertura',
    'created_date': 'Fecha de Creación',
    'closing_date': 'Fecha de Cierre',
    'failure_date': 'Fecha de Falla',
    'updated_by': 'Actualizado Por',
    'last_updated_date': 'Última Actualización',
    'description': 'Descripción',
    'attachment': 'Adjunto',
    'phone_number': 'Teléfono',
    'technician': 'Técnico',
    'project_name': 'Proyecto',
    'ttr': 'Tiempo de Resolución (H:M)',
    'needupd': 'Necesita Actualización'
}
